// extracted by mini-css-extract-plugin
module.exports = {"root":"audioInformation_root__1C-WZ","title":"audioInformation_title__2U6nE","description":"audioInformation_description__FrN1a","dash":"audioInformation_dash__lRtXY"};